import {connect} from 'formik'
import {StarredField} from 'shared'
import {PopoverIcon} from 'shared'
import {FormGroup} from './'

export const HolderFields = connect(({formik}) => {
  return <div className='donations-form-holder'>
    <div className='flex'>
      <StarredField name='first_name' placeholder={I18n.t('donate.attributes.first_name')} component={FormGroup} />
      <StarredField name='last_name' placeholder={I18n.t('donate.attributes.last_name')} component={FormGroup} />
    </div>

    <div className="input-with-popover">
      <StarredField name='email' type='email' placeholder={I18n.t('donate.attributes.email')} component={FormGroup} />
      <PopoverIcon
        popover={I18n.t('donate.email_popover')}
      />
    </div>
  </div>
})
